module.exports = __webpack_public_path__ + "img/AutoGreen.f73c2ae3.svg";